/**
 * 同账号多设备：UI 合并与上行互斥常量。
 */
/**
 * Presence 属性：上行主设备声明。
 * 格式：accountId|endpointId@epochMs（后开抢占；accountId 内嵌避免身份属性竞态）。
 */
export const MEDIA_UPLINK_OWNER_PROPERTY = 'mediaUplinkOwner';
/** 上行声明：accountId 与 endpointId 分隔符 */
export const MEDIA_UPLINK_ACCOUNT_SEPARATOR = '|';
/** 上行声明：endpointId 与时间戳分隔符 */
export const MEDIA_UPLINK_CLAIM_SEPARATOR = '@';
/**
 * Presence 属性：门户账号 id（JWT context.user.id）。
 * Prosody 未向对端广播 XMPP identity 时，用此属性做同账号识别。
 */
export const ACCOUNT_IDENTITY_PROPERTY = 'accountIdentityId';
/** 日志模块名 */
export const MULTI_DEVICE_LOG_MODULE = 'multi-device';
/** config：生效多设备模式 */
export const CONFIG_MULTI_DEVICE_MODE = 'multiDeviceMode';
/** 多设备模式：允许多端 */
export const MULTI_DEVICE_MODE_MULTI = 'MULTI';
/** 多设备模式：仅单端踢旧 */
export const MULTI_DEVICE_MODE_SINGLE = 'SINGLE';
